export const familyRows = 4;
export const familyColumns = 6;
export const familyRowsAlt = 3;
export const familyColumnsAlt = 5;
